import { get, maxBy, round, sumBy } from 'lodash'
import { numVal } from '../../../../modules/Utils'

export const initialQuoteLineState = {
  vendorQuote: {
    cost: 0,
    paymentTermsLines: [],
    days: 0,
  },
  quote: {
    paymentTermsLines: [],
  },
  delivery: {
    client: 0,
    vendor: 0,
  },
  timeline: {
    start: 0,
    end: 0,
  },
  finance: {
    cost: 0,
    credit: 0,
    difference: 0,
  },
}
export const UPDATE_VQ_COST = 'UPDATE_VQ_COST'
export const UPDATE_PAYMENT_TERMS = 'UPDATE_PAYMENT_TERMS'
export const UPDATE_FINANCE_RATE = 'UPDATE_FINANCE_RATE'
const paymentTermsOrder = ['Deposit', 'Days After Order', 'Days After Delivery']

const DEPOSIT = 'Deposit'
const DARO = 'Days After Order'
const DADO = 'Days After Delivery'

export function getDifferenceValue (cost = 0, credit = 0) {
  return cost - credit < 0 ? 0 : round(cost - credit, 2)
}

function sortPaymentsTerms (list = []) {
  return list.sort(function(a, b) {
    return paymentTermsOrder.indexOf(get(a, 'due.type')) - paymentTermsOrder.indexOf(get(b, 'due.type'))
  })
}

function quoteLineReducer (state = initialQuoteLineState, action) {
  switch (action.type) {
    case UPDATE_VQ_COST:
      return { ...state, vendorQuote: { ...state.vendorQuote, cost: action.value } }
    case UPDATE_PAYMENT_TERMS: {
      let clientPaymentTermsLines = sortPaymentsTerms(action.clientPaymentTermsLines)
      let vendorPaymentTermsLines = sortPaymentsTerms(action.vendorPaymentTermsLines)
      const clientDeliveryNo = action.clientDeliveryNo
      const vendorDeliveryNo = action.vendorDeliveryNo

      const clientDADO = numVal(
        maxBy(
          // max of DADO
          clientPaymentTermsLines.filter((p) => p.due.type === DADO),
          'due.days',
        ),
        'due.days',
      )
      const timelineEnd = clientDeliveryNo + clientDADO

      vendorPaymentTermsLines = vendorPaymentTermsLines.map((vpt) => {
        let creditDays = 0
        if (vpt.due.type === DEPOSIT) creditDays = timelineEnd
        else if (vpt.due.type === DADO) creditDays = timelineEnd - (vendorDeliveryNo + numVal(vpt, 'due.days'))
        else if (vpt.due.type === DARO) creditDays = timelineEnd - numVal(vpt, 'due.days')
        return {
          ...vpt,
          amount: (vpt.percentage / 100) * state.vendorQuote.cost,
          creditDays,
        }
      })
      const totalVendorCreditDays = sumBy(vendorPaymentTermsLines, 'creditDays')
      vendorPaymentTermsLines = vendorPaymentTermsLines.map((cpt) => {
        const financeCost = (action.financeRate / 100 / 365) * cpt.amount * numVal(cpt, 'creditDays')

        return {
          ...cpt,
          financeCost,
          creditPercentage: cpt.creditDays / totalVendorCreditDays,
        }
      })
      clientPaymentTermsLines = clientPaymentTermsLines.map((cpt) => {
        let creditDays = 0
        if (cpt.due.type === DEPOSIT) creditDays = timelineEnd
        else if (cpt.due.type === DADO) creditDays = timelineEnd - (clientDeliveryNo + numVal(cpt, 'due.days'))
        else if (cpt.due.type === DARO) creditDays = timelineEnd - numVal(cpt, 'due.days')
        const amount = (cpt.percentage / 100) * state.vendorQuote.cost
        return {
          ...cpt,
          amount,
          creditDays,
        }
      })
      const totalClientCreditDays = sumBy(clientPaymentTermsLines, 'creditDays')
      clientPaymentTermsLines = clientPaymentTermsLines.map((cpt) => {
        return {
          ...cpt,
          creditPercentage: cpt.creditDays / totalClientCreditDays,
        }
      })

      return {
        ...state,
        vendorQuote: {
          ...state.vendorQuote,
          paymentTermsLines: vendorPaymentTermsLines,
        },
        quote: {
          ...state.quote,
          paymentTermsLines: clientPaymentTermsLines,
        },
        delivery: {
          ...state.delivery,
          client: clientDeliveryNo,
          vendor: vendorDeliveryNo,
        },
        timeline: {
          ...state.timeline,
          start: 0,
          end: timelineEnd,
        },
      }
    }
    case UPDATE_FINANCE_RATE: {
      const vendorPaymentTermsLines = state.vendorQuote.paymentTermsLines.map((cpt) => {
        const financeCost = (action.financeRate / 100 / 365) * cpt.amount * numVal(cpt, 'creditDays')
        return { ...cpt, financeCost }
      })
      const clientPaymentTermsLines = state.quote.paymentTermsLines.map((cpt) => {
        const financeCredit = (action.financeRate / 100 / 365) * cpt.amount * numVal(cpt, 'creditDays')
        return { ...cpt, financeCredit }
      })
      //finance
      const fcost = round(sumBy(vendorPaymentTermsLines, 'financeCost'), 2)
      const fcredit = round(sumBy(clientPaymentTermsLines, 'financeCredit'), 2)
      const finance = {
        cost: fcost,
        credit: fcredit,
        difference: getDifferenceValue(fcost, fcredit),
      }
      return { ...state, finance }
    }
    default:
      return state
  }
}

export default quoteLineReducer
